import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Initials derived from a display name, for use as an avatar fallback: one letter for a single name, two for multiple. */
export function getInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return ""
  const initials = words.length === 1
    ? words[0][0]
    : words[0][0] + words[words.length - 1][0]
  return initials.toUpperCase()
}
